/*
PURPOSE: Editorial section marker — thin hairline rule above a small tracked
uppercase label (the base1 "01 / Why Coral exists" gutter gesture).
USE CASES:
- Section eyebrows / numerals across Home2.
DOMAIN BOUNDARIES:
- Presentation only. Label text passed as children (no copy here).
- No imports from design-sandbox/.
*/

import React from 'react';

interface EyebrowProps {
  children: React.ReactNode;
  className?: string;
}

const Eyebrow: React.FC<EyebrowProps> = ({ children, className }) => {
  return (
    <div className={className}>
      <span className="block h-px w-12 bg-editorial-muted/25" />
      <span className="mt-3 inline-block text-editorial-eyebrow uppercase text-editorial-muted/55">
        {children}
      </span>
    </div>
  );
};

export default Eyebrow;
